module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/single-selection/single-selection.component.css
// module id = ./src/app/examples/single-selection/single-selection.component.css
// module chunks = main